import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest, IFactoryResponse, IPaginated, ISkill } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import useAxios from '@/services/api/useAxios'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'

const resource = 'skills'

/**
 * @deprecated use retreiveAll
 */
const getAll = (axios: IFactoryFunctionRequest) => ({ firmId }: { firmId: string }): IFactoryResponse<Array<ISkill>> => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/firm/${firmId}`,
  })
}

// used as v2 function
const retreiveAll = (axios: IFactoryFunctionRequest) => ({ firmId = undefined, categoryIds = undefined }: { firmId?: string; categoryIds?: string[] }): IFactoryResponse<Array<ISkill>> => {
  return axios({
    method: EMethod.get,
    url: !firmId ? `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2` : `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/public/${firmId}`,
    query: {
      categoryIds,

    },
  })
}

const getFilter = (axios: IFactoryFunctionRequest<IPaginated<Pick<ISkill, '_id' | 'display'>>, undefined>) => (options = {}) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/firm/filter`,
    query: options,
  })
}

const create = (axios: IFactoryFunctionRequest<ISkill, Partial<ISkill>>) => (data: Partial<ISkill>) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}`,
    data,
  })
}

const update = (axios: IFactoryFunctionRequest<ISkill, Partial<ISkill>>) => (skillId: string, data: Partial<ISkill>) => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${skillId}`,
    data,
  })
}

const destroy = (axios: IFactoryFunctionRequest<void, undefined>) => (skillId: string) => {
  return axios({
    method: EMethod.delete,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${skillId}`,
  })
}

export default (axios: AxiosInstance) => ({
  getAll: getAll(useAxios(axios)),
  getFilter: getFilter(useAxios(axios)),
  retreiveAll: retreiveAll(useAxios(axios)),
  create: create(useAxios(axios)),
  update: update(useAxios(axios)),
  destroy: destroy(useAxios(axios)),
})
